module.exports = __webpack_public_path__ + "static/eosx-banner-2f234e8a953c4abab893c5bf9c081561.jpg";